<template>
  <v-dialog
    v-model="couponDialog"
    width="500px"
    :class="{'has-append-body':isAppendToBody}"
    :append-to-body="isAppendToBody">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <span>Add Coupons</span>
          <i
            class="el-icon-close"
            @click="changeDialog"></i>
        </div>
      </div>
      <div class="dialog-body">
        <coupon-tab
          v-if="!isQuote"
          :customerId="customerId"
          :hasDelete="false"
          :customer="customer"
          :orderId="orderId"
          @coupon="handlerCoupon"></coupon-tab>
        <quote-coupon
          v-else
          :customerId="customerId"
          :customer="customer"
          :isQuote="true"
          :orderId="orderId"
          :product="product"
          :classId="classId"
          @coupon="handlerCoupon"></quote-coupon>
      </div>
      <div class="flex footer-button">
        <v-button @click="changeDialog">Close</v-button>
        <v-button
          type="success"
          @click="ConfirmCoupon">Confirm</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import OMath from '@/utils/math'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

import quoteCoupon from '@/views/components/quote-coupon'
import couponTab from '../../accounts/components/couponsTab'

export default {
  name: 'CouponDialog',
  components: {
    couponTab,
    quoteCoupon
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    customerId: [String, Number],
    orderId: [String, Number],
    product: [String, Number],
    classId: [String, Number],
    isQuote:{
      type:Boolean,
      default:false
    },
    customer: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      couponDialog: false,
      coupon:'',
      isAppendToBody:false
    }
  },
  computed: {
    // isAppendToBody(){
    //   console.log('this--',this.appendToBody)
    //   return this.hasAppendToBody
    // }
  },
  methods: {
    changeDialog() {
      this.couponDialog = !this.couponDialog
      let {appendToBody=false} = this.customer||{}
      this.isAppendToBody = appendToBody
    },
    ConfirmCoupon(){
      this.$emit('coupon',this.coupon)
      this.couponDialog =false
    },
    handlerCoupon(data){
      this.coupon = data
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
  &.has-append-body{
    & /deep/ .el-dialog__header {
      padding: 0;
    }
    & /deep/ .el-dialog__body {
      padding: 0;
    }
  }
}
.dialog-container {
  //padding: 15px;
  border-radius: 5px;
  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .info{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;
      i{
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
  .dialog-body{
    padding: 15px;
    max-height: 500px;
    overflow-y: auto;
  }
  .footer-button{
    padding: 15px;
    justify-content: flex-end;
  }
}
</style>
